const {BASE_URL} = require('./client');

const GET_PRESIGNED_URL = BASE_URL + '/api/images/presignedurl';
const SAVE_IMAGE_METADATA = BASE_URL + '/api/images/save';
const LIST_IMAGES = BASE_URL + '/api/images/list';
const DELETE_IMAGE = BASE_URL + '/api/images/deleteimage';
module.exports = {
    GET_PRESIGNED_URL,
    SAVE_IMAGE_METADATA,
    LIST_IMAGES,
    DELETE_IMAGE
}